import axios from 'axios';

// Configure axios base URL from environment variable
const API_URL = process.env.REACT_APP_API_URL || '';

// Create axios instance with base URL
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Set default base URL for regular axios imports
axios.defaults.baseURL = API_URL;

export default axiosInstance;
